import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetOrganizationTypesMutation } from '../apis';
import type { OrganizationTypeQueryLinkerSchema } from '../schemas';

export function OrganizationTypesSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<OrganizationTypeQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: OrganizationTypeQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/organization-types/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetOrganizationTypesMutation}
      disabled={disabled}
    />
  );
}
